export default __webpack_public_path__ + "static/kimberlyclark-hover-531c3f1157a45624a342dc6b9521eb0f.png";